import { useUserStore } from "@/stores/user";
import { Navigate } from "react-router-dom";

/**
 * Guards a route so only admins (FULL_ACCESS or ADMIN roles) can access it.
 * While the user's roles are still loading from Clerk we render nothing to
 * avoid redirecting an admin before their roles have populated.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const isLoading = useUserStore((state) => state.isLoading);
  const isAdmin = useUserStore((state) => state.isAdmin());

  if (isLoading) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export default AdminRoute;
